import React from 'react';
import ReactDOM from 'react-dom';
import bbox from '@turf/bbox';
import {format} from 'd3-format';
import MapboxDraw from "@mapbox/mapbox-gl-draw";


const parcels = {
  "id": "parcels",
  "layout": {
    "visibility": "visible"
  },
  "maxzoom": 20,
  "minzoom": 13,
  "paint": {
    "fill-outline-color": "white",
    "fill-color": "transparent"
  },
  "source": {
    "tiles": [
      "https://tiles.makeloveland.com/api/v1/parcels/{z}/{x}/{y}.mvt?token="
    ],
    "type": "vector"
  },
  "source-layer": "parcels",
  "type": "fill"
}


const boundaryLabelPaint = {
  "text-color": 'white',
  "text-halo-color": "black",
  "text-halo-width": 2
}

const sectionSource = {
  "tiles": [
    "https://tileserver-sx3ktfshsq-uc.a.run.app/services/sections/tiles/{z}/{x}/{y}.pbf"
  ],
  "maxzoom": 8,
  "minzoom": 8,
  "type": "vector",
}

const townshipSource = {
  "tiles": [
    "https://tileserver-sx3ktfshsq-uc.a.run.app/services/townships/tiles/{z}/{x}/{y}.pbf"
  ],
  "type": "vector",
  "maxzoom": 9,
  "minzoom": 8,
}

// TODO combine sources
const plss = [{
  "id": "sections",
  "layout": {
    "visibility": "visible"
  },
  "maxzoom": 22,
  "minzoom": 11.5,
  "paint": {
    "line-color": "white"
  },
  "source": sectionSource,
  "source-layer": "sections",
  "type": "line"
},{
  "id": "sections-labels",
  "layout": {
    "text-field": "{FRSTDIVNO}",
    "text-allow-overlap": true
  },
  paint: boundaryLabelPaint,
  "maxzoom": 22,
  "minzoom": 11.5,
  "source": sectionSource,
  "source-layer": "sections",
  "type": "symbol"
},{
  "id": "townships",
  "layout": {
    "visibility": "visible"
  },
  "maxzoom": 22,
  "minzoom": 8.5,
  "paint": {
    "line-color": "white"
  },
  "source": townshipSource,
  "source-layer": "townships",
  "type": "line"
},{
  "id": "townships-labels",
  "layout": {
    "text-field": ["get", "TWNSHPLAB"],
    // "text-field": [
    //   "concat",
    //   ["slice", ["get", "PLSSID"], 4, 7],
    //   ["slice", ["get", "PLSSID"], 8, 9],
    //   " ",
    //   ["slice", ["get", "PLSSID"], 9, 12],
    //   ["slice", ["get", "PLSSID"], 13, 14],
    // ],
    "text-allow-overlap": true
  },
  paint: boundaryLabelPaint,
  "maxzoom": 22,
  "minzoom": 8.5,
  "source": townshipSource,
  "source-layer": "townships",
  "type": "symbol"
}]



const counties = {
  id: 'counties',
  type: 'fill',
  "maxzoom": 11,
  "minzoom": 7,
  "paint": {
    "fill-outline-color": "white",
    "fill-color": "transparent"
  },
  source: {
    type: 'geojson',
    data: 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/cb_2019_us_county_20m.json',
  }
}

const countyLabels = {
  id: 'county-labels',
  type: 'symbol',
  "maxzoom": 11,
  "minzoom": 7,
  "layout": {
    "text-field": "{NAME}",
    "text-allow-overlap": true
  },
  paint: boundaryLabelPaint,
  source: {
    type: 'geojson',
    data: 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/cb_2019_us_county_20m.json',
  }
}

// TODO
const agRegions = {
  id: 'agRegions',
  type: 'fill',
  "maxzoom": 7,
  "minzoom": 6,
  "paint": {
    "fill-outline-color": "white",
    "fill-color": "transparent"
  },
  source: {
    type: 'geojson',
    data: 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/ASD_2012_20m.json',
  }
}


const states = {
  id: 'states',
  type: 'fill',
  "maxzoom": 6,
  "minzoom": 0,
  "paint": {
    "fill-outline-color": "white",
    "fill-color": "transparent"
  },
  source: {
    type: 'geojson',
    data: 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/cb_2019_us_state_20m.json',
  }
}




const customSearchBlur = map => evt => {
  const [FRSTDIVNO, TWNSHPNO, RANGENO] = evt.target.value.split(' ');
  const pad = format("03d");
  const pad2 = format("02d");
  // 13 93 33
  // try also https://gis.blm.gov/arcgis/rest/services/Cadastral/BLM_Natl_PLSS_CadNSDI/MapServer/exts/CadastralSpecialServices/GetLatLon?trs=NV+21+T38N+R56E+SEC+10&returnalllevels=true&f=html&__ncforminfo=nfR3O2pAiqeYg3aNqRMoZeQ3cECbgdq-ySvJ5T9K03SaSdlFQ7tWls-0NiL68IAqKI5j7xGukJcCEx5AOvZ1qunDqhX4vHCBSk1htVVtm3zar8N943fLrA%3D%3D
  // backup https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/Mapserver/5
  // backup https://gis.nationalland.com/arcgis/rest/services/NLRWEB/PLSS/MapServer
  // RANGEDIR TWNSHPDIR
  fetch(`https://gis.blm.gov/arcgis/rest/services/Cadastral/BLM_Natl_PLSS_CadNSDI/MapServer/3/query?where=FRSTDIVNO%3D%27${pad2(FRSTDIVNO)}%27+and+RANGENO%3D%27${pad(RANGENO)}%27+and+TWNSHPNO%3D%27${pad(TWNSHPNO)}%27&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=4326&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson&__ncforminfo=X-eK83InQ4b9sA3piZ18YMqt62EUNgU322XICMchWzwObfMLqj_IEre8TDJsRYN3chciuNDdZghXRe661hPwaOcP_mu1IxsfO0kQqi9WFLLr39sspo2HRn-9LBy2iOijYGH3Ag8-3vYCA9cDrohN4_FMHBMekXyKqc-gH3FbadNDAblEnqJ3Qw4M7TTV12o_JdOyZun_xwHL05wmyobJ9wPTucTXiEyonyiDD-eTcTjibvhRAqIAMwliwIAGKFXS6mx9LVbtI5w0YBhTTqt0wOLzjni8UOgS_y9eyvDqC2EkEDQmhg2wL8rwv5Tfh27t4LWEkkyfuUQa-bMf9KvNKjVvfu41-j8W0tZgzPP0mhI-9CmknTh4ofeZZ3uNai8Q0kRGTzCfAM4dKBqrzSsYLhV8kktKZk-BnDgKPvPrGYE2_C5fZYXQSGiFX0iJttD8jKVzFSeydVt7k5SPsesa_Z-dkpYGS9WuAfdbjpEpdD5DorP_BYiMMrVRDUgj3-jhcm82FdoKfq8Q8T3IMKlzZMBkAQKPGpAX4G6bmkcLO-5vLtvl_U4ORrheHdcXyN9sniCk3hrZb6LhC2smbp6UO2ywy7Tn6dAzQ_tF1764K-IUwmeXi9hpCAq8NpTogakBJ158zh1wf8sh-7BiQaAmmwXeAudQoScSWqb14bkZKED2bTzwIH1aknIvoM5pcf34_cNRS91oGzmXUKZjZKJQk5GmlJwFhkkulwW1ZLD3EN-0lr47RtxoowdaJNDrfy7a4fY2q5BYhVrxAbsf0b0u6g%3D%3D`)
    .then(r => r.json())
    .then(fc => {
      const b = bbox(fc);
      if (!isFinite(b[0])) return;
      map.fitBounds([[b[0], b[1]], [b[2], b[3]]]);
    });
}

export const CustomCtrl = ({map}) => {
  return <div className="custom-ctrl mapboxgl-ctrl-geocoder mapboxgl-ctrl">
    <svg className="mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-search" viewBox="0 0 18 18" xmlSpace="preserve" width="18" height="18"><path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"></path></svg>
    <input type="text" className="mapboxgl-ctrl-geocoder--input" placeholder="Section Township Range" aria-label="Section Township Range"
      onBlur={customSearchBlur(map)}
    />
    <div className="suggestions-wrapper">
      <ul className="suggestions" style={{display: 'none'}}></ul>
    </div>
    <div className="mapboxgl-ctrl-geocoder--pin-right">
      <button aria-label="Clear" className="mapboxgl-ctrl-geocoder--button" style={{display: 'none'}}>
        <svg className="mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-close" viewBox="0 0 18 18" xmlSpace="preserve" width="18" height="18"><path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"></path></svg>
      </button>
      <svg className="mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-loading" viewBox="0 0 18 18" xmlSpace="preserve" width="18" height="18"><path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"></path><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"></path></svg>
    </div>
  </div>
}


export class CustomControl {
  onAdd(map){
    this.map = map;
    this.container = document.createElement('div');
    // this.container.className = 'mapboxgl-ctrl-geocoder mapboxgl-ctrl';
    // this.container.style.height = '36px';
    // this.container.textContent = 'Dummy control';
    ReactDOM.render(<CustomCtrl map={map} />, this.container);     
    return this.container;

  }
  onRemove(){
    try {
      this.container.remove();
      this.container.parentNode.removeChild(this.container);
    } catch (e) {
      console.log(e);
    }
    this.map = undefined;
  }
}


const onContextMenu = (drawRef, setBoundary, modelRef) => (e) => {
  const map = e.target;
  const { offsetX: x, offsetY: y } = e.originalEvent;

  console.log(modelRef)
  const rad = 10;
  const buffer = [[x - rad, y - rad], [x + rad, y + rad]];
  let layers = ['parcels'];
  if (modelRef.current === 'knowledge') layers = ['parcels', 'counties', 'agRegions', 'states'];
  const mapFeatures = map.queryRenderedFeatures(buffer, {layers: layers});
  if (mapFeatures.length > 0) {
    drawRef.current.add(mapFeatures[0]);
    setBoundary(drawRef.current.getAll());
  }

}


export const innerBoundaryToggle = ({ toggle, mapboxRef, drawRef, boundaryRef, setBoundary, ctrlRef, modelRef }) => {
  if (!mapboxRef.current) return;
  
  // start draw
  const updateGeo = e => {
    setBoundary(drawRef.current.getAll());
  }

  if (toggle) {
    mapboxRef.current.addControl(ctrlRef.current, 'top-left');

    var draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: true,
        trash: true
      }
    });
    drawRef.current = draw;

    mapboxRef.current.addControl(draw, 'top-left');      

    mapboxRef.current.on('draw.create', updateGeo);
    mapboxRef.current.on('draw.delete', updateGeo);
    mapboxRef.current.on('draw.update', updateGeo);
  
    boundaryRef.current && draw.add(boundaryRef.current);
  

  } else {
    mapboxRef.current.removeControl(ctrlRef.current);
    
    mapboxRef.current.off('draw.create', updateGeo);
    mapboxRef.current.off('draw.delete', updateGeo);
    mapboxRef.current.off('draw.update', updateGeo);
    mapboxRef.current.removeControl(drawRef.current);
    drawRef.current = null;
  }
  // end draw

  // let layers = [parcels];
  // if (model === 'knowledge') layers = [parcels, counties, countyLabels, plss, agRegions, states];
  const layers = [parcels, counties, countyLabels, ...plss, agRegions, states];
  layers.forEach(l => {
    if (mapboxRef.current.getLayer(l.id)) mapboxRef.current.removeLayer(l.id);
    if (mapboxRef.current.getSource(l.id)) mapboxRef.current.removeSource(l.id);
    if (toggle) {
      mapboxRef.current.addLayer(l, "waterway-label");
    }
  });
  if (toggle) {
    mapboxRef.current.on('contextmenu', onContextMenu(drawRef, setBoundary, modelRef));
  }
};
